import styled, { css } from "styled-components";
import { fontNormal, fontMedium, fontBold } from "../../_static/Typography";
import buildColor from "../../_static/ColorPalette";

export const InfoWrapper = styled.div`
  align-items: center;
  background-color: ${buildColor("white", "100")};
  max-width: 100%;
  padding-bottom: 20px;
  height: auto;
  flex-wrap: wrap;
  ${({ full }) =>
    full
      ? css`
          display: column;
          margin: auto;
          padding-top: 22px;
        `
      : css`
          display: flex;
        `}
`;

export const InfoLogoWrapper = styled.span`
  position: relative;
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  margin-right: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${buildColor("grey", "100")};
  border-radius: 40px;
  ${({ full }) =>
    full &&
    css`
      margin: auto;
    `}
`;

export const IconExclamationContainer = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${buildColor("white", "100")};
  border-radius: 12px;
  width: 16px;
  height: 16px;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  word-wrap: break-word;
  ${({ full }) =>
    full &&
    css`
      margin-top: 22px;
    `}
`;

export const InfoTitle = styled.p`
  color: ${buildColor("grey", "900")};
  font-family: ${fontBold};
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0;
  ${({ full }) =>
    full &&
    css`
      margin: auto;
    `}
`;

export const InfoMessage = styled.p`
  color: ${buildColor("grey", "600")};
  font-size: 14px;
  font-family: ${fontNormal};
  font-weight: 400;
  letter-spacing: 0;
  padding-top: 4px;
  padding-right: 22px;
  ${({ full }) =>
    full &&
    css`
      margin: auto;
      text-align: center;
      padding: 4px 22px 0;
    `}
`;

export const ButtonContainer = styled.div`
  background: ${buildColor("white", "100")};
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 12px 12px 8px;

  & > button {
    border-radius: 2px;
    height: 32px;
    background: none;
    border: 1px solid ${buildColor("blue", "100")};
    font-family: ${fontMedium};
    font-size: 12px;
    letter-spacing: 0;
    text-align: center;
    text-transform: none;

    &:hover {
      background: ${buildColor("blue_accent", "100")};
    }
  }
`;
